import { defineComponent as Q, computed as v, ref as W, createElementBlock as s, openBlock as d, createElementVNode as r, mergeProps as L, createCommentVNode as b, renderSlot as k, createTextVNode as x, toDisplayString as p, normalizeClass as i, createBlock as I, unref as u, withCtx as y, Fragment as C, renderList as T, createVNode as X, withDirectives as Y, vShow as Z } from "vue";
import { RevButtonIcon as O } from "@ds/components/ButtonIcon";
import { RevCheckbox as j } from "@ds/components/Checkbox";
import D from "../CheckboxBase/CheckboxBase.vue2.js";
import { RevTooltip as _ } from "@ds/components/Tooltip";
import { usePropsValidation as ee } from "../../composables/usePropsValidation.js";
import te from "../../icons/generated/IconChevronDown.vue2.js";
import le from "../../icons/generated/IconChevronUp.vue2.js";
import ae from "../../icons/generated/IconInfo.vue2.js";
import { tw as o } from "../../utils/tailwind.js";
import oe from "./components/TableSortingHeader.vue2.js";
const de = {
  key: 0,
  class: "heading-2 m-24 text-left"
}, ne = { class: "block md:table-row" }, se = {
  key: 0,
  class: "px-16 text-start first:pl-24",
  scope: "col"
}, ce = ["id"], re = { class: "flex items-center" }, ie = ["id"], ue = ["headers"], be = ["headers"], fe = ["id", "aria-expanded"], he = { colspan: "100" }, me = ["id", "aria-expanded"], pe = { colspan: "100" }, Be = /* @__PURE__ */ Q({
  name: "RevTable",
  __name: "Table",
  props: {
    caption: { default: "" },
    checkedIds: { default: void 0 },
    selectAllLabel: { default: "Select All" },
    showCheckboxesLabels: { type: Boolean, default: !1 },
    collection: {},
    getCollectionItemId: { type: Function, default: (t) => typeof t == "object" && t !== null && "id" in t ? t.id : "" },
    columns: {},
    stripedRows: { type: Boolean, default: !1 },
    sortOptions: { default: null },
    transparentHeader: { type: Boolean, default: !1 },
    expandLabel: { default: "Expand" },
    expandRowsByDefault: { type: Boolean, default: !1 },
    shouldMountExpandedRows: { type: Boolean, default: !1 }
  },
  emits: ["update:sortOptions", "update:checkedIds", "update:expandAll", "update:expandedRow"],
  setup(t, { expose: M, emit: S }) {
    const a = t, f = S;
    ee({
      "`props.selectAllLabel` should be provided if `props.checkedIds` was chosen": () => a.checkedIds && !a.selectAllLabel,
      "collection items should have an id property or a `getCollectionItemId` method should be provided if `checkedIds` or `expandable` rows are used": () => a.checkedIds || a.collection.some((l) => l.expandable) ? a.collection.some(
        (l) => a.getCollectionItemId(l) === void 0
      ) : !1
    });
    const g = v(() => ({
      align: "end",
      key: "expand",
      label: a.expandLabel
    })), w = v(
      () => a.collection.length === a.checkedIds?.length
    ), U = v(() => [
      o`border-static-default-low body-1-bold h-56 border-b-1`,
      o`hidden`,
      o`md:table-row-group`,
      a.transparentHeader ? o`bg-transparent` : o`bg-static-default-hi`
    ]), $ = v(() => [
      o`bg-static-default-min`,
      o`mt-24 block`,
      o`md:border-static-default-low md:mt-0 md:table-row md:border-b-1 md:last:border-b-0`,
      a.stripedRows && o`md:even:bg-static-default-mid`
    ]), F = v(() => [
      o`px-16`,
      o`border-static-default-low flex items-center justify-between border-b-1 py-12 before:content-[attr(headers)] first:pl-24`,
      o`md:table-cell md:border-none md:py-24 md:before:content-none`,
      a.stripedRows && o`md:even:bg-static-default-mid`
    ]), z = (l) => [
      o`px-16 first:pl-24`,
      l.highlighted && o`bg-static-info-low`
    ], A = (l) => [
      o`group`,
      o`border-static-default-low border-b-1 md:border-none `,
      o`before:body-1-bold before:px-16 before:py-12 before:content-[attr(headers)] md:before:content-none`,
      o`flex items-center justify-between md:table-cell`,
      a.stripedRows && !l.highlighted && o`even:bg-static-default-mid md:even:before:bg-static-default-hi even:md:bg-transparent`,
      l.highlighted && o`bg-static-info-low`
    ], H = (l) => [
      o`mr-8 text-left`,
      l.headerClassNames
    ], N = (l) => [
      o`flex items-center px-16 py-12 text-end md:py-24 md:text-start md:group-first-of-type:pl-24 md:group-last-of-type:pr-24`,
      l.isTabular && o`justify-end tabular-nums`,
      !l.isTabular && !l.align && o`justify-start`,
      !l.isTabular && l.align === "start" && o`justify-start`,
      !l.isTabular && l.align === "center" && o`justify-center`,
      !l.isTabular && l.align === "end" && o`justify-end`
    ];
    function P(l) {
      return a.sortOptions?.sortBy === l && a.sortOptions?.sortOrder || "UNDEFINED";
    }
    function q(l, n) {
      f("update:sortOptions", { sortBy: l, sortOrder: n });
    }
    function B() {
      if (w.value)
        f("update:checkedIds", []);
      else {
        const l = a.collection.map(
          (n) => a.getCollectionItemId(n)
        );
        f("update:checkedIds", l);
      }
    }
    function E(l) {
      if (!a.checkedIds)
        return;
      const n = a.getCollectionItemId(l);
      a.checkedIds.includes(n) ? f(
        "update:checkedIds",
        a.checkedIds.filter((e) => e !== n)
      ) : f("update:checkedIds", [...a.checkedIds, n]);
    }
    function G() {
      return a.collection.filter((n) => n.expandable).reduce((n, e) => ({
        ...n,
        [a.getCollectionItemId(e)]: a.expandRowsByDefault
      }), {});
    }
    const h = W(G()), R = v(() => a.collection.some((l) => l.expandable !== void 0));
    function J(l) {
      const n = !h.value[a.getCollectionItemId(l)];
      h.value[a.getCollectionItemId(l)] = n, f("update:expandedRow", a.getCollectionItemId(l), n);
    }
    const V = (l) => {
      const n = a.collection.filter((e) => e.expandable);
      n.length !== 0 && (h.value = n.reduce(
        (e, m) => ({
          ...e,
          [a.getCollectionItemId(m)]: l
        }),
        {}
      ));
    };
    return M({
      expandAll: () => {
        V(!0), f("update:expandAll", !0);
      },
      collapseAll: () => {
        V(!1), f("update:expandAll", !1);
      }
    }), (l, n) => (d(), s("div", null, [
      r("table", L({
        ...R.value && { "aria-live": "polite" }
      }, { class: "text-static-default-mid body-1 w-full border-collapse border-spacing-0 border-0" }), [
        t.caption ? (d(), s("caption", de, [
          k(l.$slots, "caption", { caption: t.caption }, () => [
            x(p(t.caption), 1)
          ])
        ])) : b("", !0),
        r("thead", {
          class: i(U.value)
        }, [
          r("tr", ne, [
            t.checkedIds ? (d(), s("th", se, [
              t.showCheckboxesLabels ? (d(), I(u(j), {
                key: 1,
                id: "table-select-all",
                "model-value": w.value,
                value: "select-all",
                "onUpdate:modelValue": B
              }, {
                label: y(() => [
                  x(p(t.selectAllLabel), 1)
                ]),
                _: 1
              }, 8, ["model-value"])) : (d(), I(u(D), {
                key: 0,
                id: "table-select-all",
                label: t.selectAllLabel,
                "model-value": w.value,
                value: "select-all",
                "onUpdate:modelValue": B
              }, null, 8, ["label", "model-value"]))
            ])) : b("", !0),
            (d(!0), s(C, null, T(t.columns, (e) => (d(), s("th", {
              id: e.label,
              key: e.key,
              class: i(z(e)),
              scope: "col"
            }, [
              r("div", re, [
                r("span", {
                  class: i(H(e))
                }, p(e.label), 3),
                e.isSortable ? (d(), I(oe, {
                  key: 0,
                  value: P(e.key),
                  onChange: (m) => q(e.key, m)
                }, null, 8, ["value", "onChange"])) : b("", !0),
                e.description ? (d(), I(u(_), {
                  key: 1,
                  class: "ml-2"
                }, {
                  trigger: y(({ show: m, hide: c, ...K }) => [
                    X(u(O), L({ icon: u(ae) }, { ref_for: !0 }, K, {
                      size: "small",
                      variant: "secondary",
                      onBlur: c,
                      onFocusin: m,
                      onMouseleave: c,
                      onMouseover: m
                    }), null, 16, ["icon", "onBlur", "onFocusin", "onMouseleave", "onMouseover"])
                  ]),
                  default: y(() => [
                    x(" " + p(e.description), 1)
                  ]),
                  _: 2
                }, 1024)) : b("", !0)
              ])
            ], 10, ce))), 128)),
            R.value ? (d(), s("th", {
              key: 1,
              id: g.value.label,
              class: "px-16 text-end",
              scope: "col"
            }, p(g.value.label), 9, ie)) : b("", !0)
          ])
        ], 2),
        r("tbody", null, [
          (d(!0), s(C, null, T(t.collection, (e, m) => (d(), s(C, {
            key: t.getCollectionItemId(e)
          }, [
            r("tr", {
              class: i($.value),
              scope: "row"
            }, [
              t.checkedIds ? (d(), s("td", {
                key: 0,
                class: i(F.value),
                headers: ""
              }, [
                t.showCheckboxesLabels ? (d(), I(u(j), {
                  key: 1,
                  id: `checkbox-${t.getCollectionItemId(e)}`,
                  "model-value": t.checkedIds.includes(t.getCollectionItemId(e)),
                  value: `checkbox-${t.getCollectionItemId(e)}`,
                  "onUpdate:modelValue": (c) => E(e)
                }, {
                  label: y(() => [
                    x(p(
                      // Fallback hardcoded value for backward compatibility
                      e.rowCheckboxLabel || "Select One"
                    ), 1)
                  ]),
                  _: 2
                }, 1032, ["id", "model-value", "value", "onUpdate:modelValue"])) : (d(), I(u(D), {
                  key: 0,
                  id: `checkbox-${t.getCollectionItemId(e)}`,
                  label: e.rowCheckboxLabel || `${e?.title || t.columns[0]?.label || m}-${t.getCollectionItemId(e)}`,
                  "model-value": t.checkedIds.includes(t.getCollectionItemId(e)),
                  value: `checkbox-${t.getCollectionItemId(e)}`,
                  "onUpdate:modelValue": (c) => E(e)
                }, null, 8, ["id", "label", "model-value", "value", "onUpdate:modelValue"]))
              ], 2)) : b("", !0),
              (d(!0), s(C, null, T(t.columns, (c) => (d(), s("td", {
                key: c.key,
                class: i(A(c)),
                headers: c.label
              }, [
                r("div", {
                  class: i(N(c))
                }, [
                  k(l.$slots, `body-${c.key}`, {
                    column: c,
                    item: e
                  }, () => [
                    x(p(e?.[c.key]), 1)
                  ])
                ], 2)
              ], 10, ue))), 128)),
              R.value ? (d(), s("td", {
                key: 1,
                class: i(A(g.value)),
                headers: g.value.label
              }, [
                r("div", {
                  class: i(N(g.value))
                }, [
                  e.expandable ? (d(), I(u(O), {
                    key: 0,
                    "alternative-text": g.value.label,
                    "aria-controls": `expand-${t.getCollectionItemId(e)}`,
                    icon: h.value[t.getCollectionItemId(e)] ? u(le) : u(te),
                    size: "small",
                    variant: "secondary",
                    onClick: (c) => J(e)
                  }, null, 8, ["alternative-text", "aria-controls", "icon", "onClick"])) : b("", !0)
                ], 2)
              ], 10, be)) : b("", !0)
            ], 2),
            !t.shouldMountExpandedRows && h.value[t.getCollectionItemId(e)] ? (d(), s("tr", {
              key: 0,
              id: `expand-${t.getCollectionItemId(e)}`,
              "aria-expanded": h.value[t.getCollectionItemId(e)],
              class: i($.value)
            }, [
              r("td", he, [
                k(l.$slots, `expand-${t.getCollectionItemId(e)}`, { item: e })
              ])
            ], 10, fe)) : t.shouldMountExpandedRows ? Y((d(), s("tr", {
              key: 1,
              id: `expand-${t.getCollectionItemId(e)}`,
              "aria-expanded": h.value[t.getCollectionItemId(e)],
              class: i($.value)
            }, [
              r("td", pe, [
                k(l.$slots, `expand-${t.getCollectionItemId(e)}`, { item: e })
              ])
            ], 10, me)), [
              [
                Z,
                t.shouldMountExpandedRows && h.value[t.getCollectionItemId(e)]
              ]
            ]) : b("", !0)
          ], 64))), 128))
        ])
      ], 16)
    ]));
  }
});
export {
  Be as default
};
